import React from "react";
import { ChevronRight } from "lucide-react";

// LOGOS
import adpLogo from "../../../assets/EMP_HealthcareIntegrationSection/adp-platinum-partner-logo-scaled.webp";

import alightLogo from "../../../assets/EMP_HealthcareIntegrationSection/market-place-alight.webp";

import parLogo from "../../../assets/EMP_HealthcareIntegrationSection/par-logo.webp";

import oracleLogo from "../../../assets/EMP_HealthcareIntegrationSection/oracle-partner-logos.webp";

import workdayLogo from "../../../assets/EMP_HealthcareIntegrationSection/dailypay-workday-logo-new.webp";

import sapLogo from "../../../assets/EMP_HealthcareIntegrationSection/sap-partner-logo-1.webp";

import paycorLogo from "../../../assets/EMP_HealthcareIntegrationSection/market-place-paycor.webp";

import ukgLogo from "../../../assets/EMP_HealthcareIntegrationSection/market-place-ukg.webp";

import viventiumLogo from "../../../assets/EMP_HealthcareIntegrationSection/market-place-viventium.webp";

export default function HealthcareIntegrationSection() {

  const logos = [
    adpLogo,
    alightLogo,
    parLogo,
    oracleLogo,
    workdayLogo,
    sapLogo,
    paycorLogo,
    ukgLogo,
    viventiumLogo,
  ];

  return (
    <section className="w-full bg-white py-20">

      <div className="max-w-[1320px] mx-auto px-6">

       <div
  className="
    bg-[#f2efed]
    rounded-[40px]
    px-8
    lg:px-14
    py-12
    lg:py-16

    min-h-[420px]

    flex
    flex-col
    lg:flex-row
    items-center
    justify-between
    gap-16
    overflow-visible
    relative
  "
>

          {/* LEFT CONTENT */}
          <div className="w-full lg:w-[42%] relative z-10">

            <h2
              className="
                text-[42px]
                lg:text-[38px]
                leading-[1.05]
                lg:leading-[1.3]
                text-[#2b0000]
                font-semibold
                lg:-mt-[60px]
              "
            >
              Healthcare Payroll Integration <br /> Simplified  With DailyPay
            </h2>

            <p
              className="
                mt-10
                text-[18px]
                lg:text-[16px]
                leading-[1.3]
                text-black
                font-sans
              "
            >
              DailyPay integrates with healthcare payroll systems like
              ADP and Workday, and 180+ HCM, payroll and time
              management systems to deliver its industry-leading
              On-Demand Pay platform to millions of users. Partnering
              with DailyPay does not add any extra burden for your
              team. We take pride in handling the hard work of getting
              DailyPay up and running for you.
            </p>

            <button
              className="
                mt-10
                flex
                items-center
                gap-2
                text-[18px]
                lg:text-[16px]
                font-bold
                text-black
                hover:text-[#5b0000]
                transition-all
              "
            >
              See who we integrate with

              <ChevronRight size={24} />
            </button>

          </div>

         <div
  className="
    relative
    z-10
    grid
    grid-cols-2
    sm:grid-cols-3
    gap-5
    items-start
    
  "
>

  {logos.map((logo, index) => (

    <div
      key={index}
      className={`
        bg-white
        h-[120px]
        lg:h-[90px]
        flex
        items-center
        justify-center
        shadow-sm

        ${index % 3 === 1 ? "lg:-mt-6" : ""}
        ${index % 3 === 2 ? "lg:-mt-12" : ""}
      `}
    >

      <img
        src={logo}
        alt=""
        className="
          max-w-[75%]
          max-h-[70%]
          object-contain
        "
      />

    </div>

  ))}

</div>

          </div>

        </div>


    </section>
  );
}